jQuery(document).ready(function($) {
	if (typeof gtag !== 'function') return;

	// Search
	$('.searchform').on('submit', function() {
		if (typeof gtag !== 'function') return;

		var $form = $(this);
		var $input = $form.find('input[name="s"]').first();

		if (!$input.length) return;

		var searchTerm = $.trim($input.val());

		if (!searchTerm) return;

		gtag('event', 'search_guideline', {
			search_term: searchTerm
		});

	});


	// Outbound Links
	$('a[href^="http"]').on('click', function(e) {
		var href = $(this).attr('href');

		var url;
		try {
			url = new URL(href, window.location.origin);
		} catch (err) {
			return;
		}
		if (url.host === window.location.host) return;

		gtag('event', 'outbound_click', {
			link_url: href,
			// link_text: $(this).text().trim(),
		});
	});

	// Navigation Path Events (Guidelines, Menu Clicks, Breadcrumbs)

	// Header nav
	$('.header .navbar-nav a').on('click', function(e) {
		var $link = $(this);
		gtag('event', 'navigation_click', {
			nav_label: $link.text().trim(),
			nav_url: $link.attr('href'),
			nav_type: 'header'
		});
	});

	// Footer nav
	$('.footer ul li a').on('click', function(e) {
		var $link = $(this);
		gtag('event', 'navigation_click', {
			nav_label: $link.text().trim(),
			nav_url: $link.attr('href'),
			nav_type: 'footer'
		});
	});

	// Breadcrumbs
	$('.kama_breadcrumbs a').on('click', function(e) {
		var $link = $(this);
		gtag('event', 'navigation_click', {
			nav_label: $link.text().trim(),
			nav_url: $link.attr('href'),
			nav_type: 'breadcrumb'
		});
	});

	// Sidebar guides
	$('.sidebar a').on('click', function(e) {
		var $link = $(this);
		gtag('event', 'navigation_click', {
			nav_label: $link.text().trim(),
			nav_url: $link.attr('href'),
			nav_type: 'sidebar'
		});
	});


	// Document Downloads

	// Files inside category, post or specifications page
	$('.files__icons a').on('click', function(e) {
		var $link = $(this);
		var href = $link.attr('href');
		var fileType = href.split('.').pop().toLowerCase();
		var source = '';

		if ($link.closest('.specifications').length) source = 'specifications';
		else if ($link.closest('article').length) source = 'category';
		else if ($link.closest('.single').length) source = 'single';
		else source = 'other';

		gtag('event', 'document_download', {
			doc_url: href,
			doc_type: fileType,
			source: source
		});
	});

	// Inside post
	$('.js-download-all').on('click', function(e) {
		gtag('event', 'document_download', {
			doc_url: 'all',
			doc_type: 'all',
			source: 'post'
		});
	});

	// Inside specifications
	$('.js-download-selected').on('click', function(e) {
		gtag('event', 'document_download', {
			doc_url: 'selected',
			doc_type: 'selected',
			source: 'specifications'
		});
	});

	// Popular Guideline Pages
	// Only track when we're *inside* a single post page
	if ($('.single__content').length > 0) {
		gtag('event', 'popular_guideline', {
			page_title: $('.single .section-title').text().trim(),
			page_url: window.location.href,
			page_type: 'single'
		});
	}
});